import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'json-to-csv',
  version: '1.0.0',
  properties: [
    {
      key: 'inputData',
      label: 'Input Data',
      type: 'string',
      required: false,
      default: '',
      placeholder: 'e.g., {{ $node["Previous Node"].output.data }}',
      description: 'JSON array to convert. Leave empty to use data from previous node.',
    },
    {
      key: 'delimiter',
      label: 'Delimiter',
      type: 'string',
      default: ',',
      placeholder: ',',
      description: 'Character to separate values',
    },
    {
      key: 'includeHeaders',
      label: 'Include Headers',
      type: 'boolean',
      default: true,
      description: 'Include column headers in the first row',
    },
    {
      key: 'fields',
      label: 'Fields',
      type: 'string',
      default: '',
      placeholder: 'name,email,age (leave empty for all fields)',
      description: 'Comma-separated list of fields to include. Leave empty to include all fields.',
    },
    {
      key: 'quoteStrings',
      label: 'Quote Strings',
      type: 'boolean',
      default: true,
      description: 'Wrap string values in quotes',
    },
  ],
};

export default schema;
